export default __webpack_public_path__ + "static/media/interactAssistantAvatar.17a42264.png";